import { render, staticRenderFns } from "./CTA05.vue?vue&type=template&id=ec7ba1ca"
import script from "./CTA05.vue?vue&type=script&lang=js"
export * from "./CTA05.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports